import React, { useState } from 'react';
import { useNCZIContext } from '../../../Services/NCZIContext';
import useNCZI from '../../../Hooks/useNCZI';
import { useEffectAsync } from '../../../../../helpers';
import { usePatientTreatmentContext } from '../../../../Patient/Components/PatientTreatment/ContextProvider';
import ElectronicHealthCardContactInfoJRUZ from './ElectronicHealthCardContactInfoJRUZ/ElectronicHealthCardContactInfoJRUZ';
import NCZICommandResult from '../../NCZICommandResult/NCZICommandResult';
import NavigationStepper, {
	NavigationStepperItemType,
} from '../../../../../Components/Stepper/NavigationStepper';
import ElectronicHealthCardInfoContactWrapper from './ElectronicHealthCardContactInfoContact/ElectronicHealthCardInfoContactWrapper';
import ElectronicHealthCardContactInfoContactPersonsWrapper from './ElectronicHealthCardContactInfoContactPersons/ElectronicHealthCardContactInfoContactPersonsWrapper';
import ElectronicHealthCardContactInfoPreferredHealthProfessionalsWrapper from './ElectronicHealthCardContactInfoPreferredHealthProfessionals/ElectronicHealthCardContactInfoPreferredHealthProfessionalsWrapper';
import apiClient from '../../../../../Services/ApiClient';

//@ts-ignore
import styles from './ElectronicHealthCardContactInfo.module.scss';

interface Props {
	setIsLoading: (isLoading: boolean) => void;
}

const ElectronicHealthCardContactInfo: React.FC<Props> = () => {
	const { patientSummaryContactData, patientIdentifier, setPatientSummaryContactData } = useNCZIContext();
	const { patientId } = usePatientTreatmentContext();
	const { fetchPatientSummaryContactData } = useNCZI();
	const [loadingCommandId, setLoadingCommandId] = useState<string | undefined>(
		undefined,
	);

	const handleLoadPatientContactData = async () => {
		if (patientIdentifier) {
			const command = await fetchPatientSummaryContactData(patientIdentifier);
			if (command.id) {
				setLoadingCommandId(command.id);
			}
		}
	};

	const handleLoadData = async () => {
		if (!patientSummaryContactData) {
			// // todo for test
			// const { data: response } = await apiClient.get(
			// 	'/nczi/message/13e7c537-1ace-47eb-ba71-bf5c2e9d5de2/response',
			// );
			// setPatientSummaryContactData(response.data);
			// // todo for test

			await handleLoadPatientContactData();
		}
	};

	useEffectAsync(async () => {
		await handleLoadData();
	});

	if (!patientSummaryContactData || !patientIdentifier) {
		return (
			<div className={styles.wrapper}>
				<div className={styles.content}>
					<NCZICommandResult
						commandId={loadingCommandId}
						handleRetryCommand={handleLoadData}
					/>
				</div>
			</div>
		);
	}

	const navigationSteps: NavigationStepperItemType[] = [
		{
			name: 'Kontaktní informace',
			key: 'contactInformation',
			component: () => (
				<ElectronicHealthCardInfoContactWrapper
					patientIdentifier={patientIdentifier}
					setLoadingCommandId={setLoadingCommandId}
					patientName={patientSummaryContactData?.patientJRUZ?.person?.fullName}
				/>
			),
		},
		{
			name: 'Kontaktní osoby',
			key: 'contactPersons',
			component: () => (
				<ElectronicHealthCardContactInfoContactPersonsWrapper
					patientIdentifier={patientIdentifier}
					setLoadingCommandId={setLoadingCommandId}
				/>
			),
		},
		{
			name: 'Preferovaní zdravotní pracovníci',
			key: 'preferredParamedic',
			component: () => (
				<ElectronicHealthCardContactInfoPreferredHealthProfessionalsWrapper
					patientIdentifier={patientIdentifier}
					setLoadingCommandId={setLoadingCommandId}
				/>
			),
		},
	];

	if (patientSummaryContactData?.patientJRUZ) {
		navigationSteps.push({
			name: 'JRUZ',
			key: 'JRUZ',
			component: () => (
				<ElectronicHealthCardContactInfoJRUZ data={patientSummaryContactData.patientJRUZ} />
			),
		});
	}

	return (
		<div className={styles.wrapper}>
			<NavigationStepper
				steps={navigationSteps}
				initialStepPath='contactInformation'
				canSkip
			/>
		</div>
	);
};

export default ElectronicHealthCardContactInfo;
